/** SigninRedirectPage - Callback nakon eID login-a (/signin-oidc). Logika u useAuthRedirect. */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '@/core/auth/AuthService';
import LoadingOverlay from '@/shared/components/LoadingOverlay';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';
import { useAuthRedirect } from './hooks/useAuthRedirect';

const SigninRedirectPage = () => {
  useDocumentTitle('Пријава - Партнерство за отворену управу');
  const navigate = useNavigate();
  const { isLoading, error, loadingStep } = useAuthRedirect();

  if (error && !isLoading) {
    const isStateError = error.includes('No matching state') || error.includes('state');
    return (
      <div className="loading-overlay" role="dialog" aria-live="assertive" aria-labelledby="error-title">
        <div className="loading-overlay-content error-content">
          <div className="error-icon">❌</div>
          <h2 id="error-title" className="loading-title error-title">Greška pri prijavljivanju</h2>
          <p className="loading-message error-message">
            {isStateError ? 'Session storage је обрисан. Молимо покушајте поново.' : error}
          </p>
          <div className="error-actions">
            <button onClick={() => { window.history.replaceState({}, document.title, window.location.pathname); AuthService.login(); }} className="btn btn-primary">🔄 Pokušaj ponovo</button>
            <button onClick={() => navigate('/')} className="btn btn-secondary">Nazad na početnu</button>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) return <LoadingOverlay isLoading={isLoading} title="Пријављивање у току..." message={loadingStep} steps={['Povezivanje sa sistemom', 'Provera podataka', 'Završavanje prijave']} />;

  return null;
};

export default SigninRedirectPage;
